import ModelUtil from '@leverege/model-util';
const TYPE = 'attr.customTextAttribute.resourceImage';
function create(opts) {
  const {
    attrName,
    objectType
  } = opts || {};
  return {
    type: TYPE,
    attrName,
    objectType,
    dimensions: {
      width: 200,
      height: 200
    },
    verticalAlign: 'middle'
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('dimensions/width', 'width'),
  ...ModelUtil.createAllValue('dimensions/height', 'height'),
  ...ModelUtil.createAllValue('verticalAlign')
};